export default "__VITE_ASSET__CBWVtVxU__"